// Central site + brand configuration.
// FOUNDER: swap SOCIAL_LINKS placeholders and drop the real logo file in
// /app/frontend/public/logo.svg (or .png) — the <Logo /> component picks it up
// automatically. If no file is present it falls back to a code-built mark.

export const BRAND = {
    name: 'Synthetic Media Investigator',
    short: 'S.M.I.',
    tagline: 'Learn AI. Uncover the data. Protect the truth.',
    // GEO/SEO title — founder-approved 2026-06: brand + category keywords, 60 chars.
    seoTitle: 'Synthetic Media Investigator | AI Automation & Verification',
    subline: 'AI automation & education — truth, data, and creator rights protected by cryptography.',
    description:
        'SMI is an AI systems, automation, education, and digital trust platform. Deploy prebuilt AI agents, automate business operations, learn how AI works, verify synthetic media, and establish cryptographic provenance — from a single automation to an interconnected AI workforce.',
    // Single site-wide meta description — founder ruling 2026-06 (D3 CLOSED).
    // All previously competing default description strings are retired.
    metaDescription:
        'Explore AI automation, practical tools, and AI education from Synthetic Media Investigator. Put AI to work while keeping people in control.',
    // Path the <Logo /> component will use. If /public/logo.png exists it is used;
    // otherwise the built-in mark is rendered.
    logoImage: '/logo.svg',
    // Copyright entity — appears in footer.
    entity: 'Synthetic Media Investigator',
};

export const SOCIAL_LINKS = [
    {
        name: 'Instagram',
        href: 'https://instagram.com/s__m__investigator',
        icon: 'instagram',
        testid: 'social-instagram',
    },
    {
        name: 'TikTok',
        href: 'https://www.tiktok.com/@smi22887',
        icon: 'tiktok',
        testid: 'social-tiktok',
    },
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/Synthetic-Media-Investigator',
        icon: 'facebook',
        testid: 'social-facebook',
    },
    {
        name: 'YouTube',
        href: 'https://www.youtube.com/@S-M_Investigations',
        icon: 'youtube',
        testid: 'social-youtube',
    },
];

export const ANALYTICS_CONFIG = {
    backendEnabled: true,
    ga4: { enabled: false, measurementId: '' },
    plausible: { enabled: false, domain: '' },
};

export const SITE_URL = process.env.REACT_APP_SITE_URL || '';

// Approved 2026-09-30 (Ryan): public "Book a call" link beside quote actions.
export const BOOKING_URL = 'https://calendly.com/subfrecuency';
